import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MaintenanceComponent} from './maintenance.component';
import {TranslateModule} from '@xref/ngx';
import {MaintenanceService} from '../../services/maintenance/maintenance.service';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule
  ],
  declarations: [
    MaintenanceComponent
  ],
  providers: [
    MaintenanceService
  ]
})
export class MaintenanceModule {}
